import { Link } from "react-router-dom";
import { categories } from "@/mocks/home";

export default function HomeCategories() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            社区板块
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索你感兴趣的板块
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            六大核心板块，涵盖生活方方面面，总有一个适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-100 transition-all duration-300"
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <h3 className="font-heading font-semibold text-foreground-900">{cat.name}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.articleCount.toLocaleString()} 篇</span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3">{cat.desc}</p>
                  <div className="flex items-center gap-1 text-primary-500 text-sm font-medium">
                    <span>浏览板块</span>
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}